import { useContext, useState } from "react";
import { observer } from "mobx-react-lite";
import { HelpCircleIcon } from "lucide-react";

import { LLMProvider } from "../GeneralParameters/LLMProvider";
import { LLMModel } from "../GeneralParameters/LLMModel";
import { APISelector } from "../GeneralParameters/APISelector";
import { DECISIONS_API } from "../constants";
import { DecisionQuestionsEditor } from "../DecisionQuestionsEditor";
import { useParameters } from "../store";

import { Controls } from "./Controls";
import { ModelParametersInfoModal } from "./ModelParametersInfoModal";

import { BasicTooltip } from "@/components/ui/Tooltip";
import { PlaygroundStoreContext } from "@/components/Playground/playground-store";
import { TOUR_TARGET_IDS } from "@/components/Playground/tour/constants";
import TourTargetContainer from "@/components/Playground/tour/TourTargetContainer";
import { Button } from "@/components/ui/button";

export const EditParameters = observer(
  ({ shouldShowClearButton = true }: { shouldShowClearButton?: boolean }) => {
    const store = useParameters();
    const isPlayground = useContext(PlaygroundStoreContext);
    const [helpModalOpen, setHelpModalOpen] = useState(false);

    return (
      <div className="flex w-full flex-col gap-4">
        <div className="relative">
          <div className="absolute right-0 top-0">
            <BasicTooltip content="View model pricing and comparison information">
              <HelpCircleIcon
                className="h-5 w-5 cursor-pointer rounded-full text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-700"
                onClick={() => setHelpModalOpen(true)}
              />
            </BasicTooltip>
          </div>
          <TourTargetContainer id={TOUR_TARGET_IDS.MODEL_PROVIDER_SECTION}>
            <LLMProvider />
            <LLMModel />
          </TourTargetContainer>
          <APISelector />
          {store.selectedAPI === DECISIONS_API ? <DecisionQuestionsEditor /> : <Controls />}
        </div>
        {!isPlayground && shouldShowClearButton && (
          <div className="flex items-center justify-center">
            <Button
              type="button"
              onClick={() => {
                store.clearModelData();
              }}
              variant="destructiveOutline"
            >
              Clear Parameters
            </Button>
          </div>
        )}

        <ModelParametersInfoModal open={helpModalOpen} onOpenChange={setHelpModalOpen} />
      </div>
    );
  },
);
